export const normalizeInitialFormValues = (item, keyIn, defaultValue = '') => {
  if (item && item.getIn(keyIn) != null) {
    if (item.getIn(keyIn) === true || item.getIn(keyIn) === false) {
      return item.getIn(keyIn);
    }
    return `${item.getIn(keyIn)}`;
  }
  return defaultValue;
};

export const isString = value => typeof value === 'string' || value instanceof String;

export const isNumber = value => typeof value === 'number' || value instanceof Number;

export const isBoolean = value => typeof value === 'boolean' || value instanceof Boolean;

export const fieldToNumber = (value) => {
  if (isNumber(value) && !Number.isNaN(value)) {
    return value;
  }
  if (isString(value) && value.trim()) {
    const maybeNumber = Number(value.trim());
    if (Number.isNaN(maybeNumber)) {
      return undefined;
    }
    return maybeNumber;
  }
  return undefined;
};

export const fieldTrimmed = (value) => {
  if (value == null) {
    return undefined;
  }
  if (isString(value) || isNumber(value)) {
    const strVal = `${value}`;
    if (strVal && strVal.trim()) {
      return strVal.trim();
    }
  }
  return undefined;
};
